﻿$.fn.dxCtrlPageEmail = function custom_dxCtrlPageEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpageemail dx-ctrl");
        this.createInstance(new cdxCtrlPageEmail(this, option));
    }
    return this;
}

window.cdxCtrlPageEmail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "grid_email_avec_classeur"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}

    option.bddCtrl.mAddFunctionOnModifiedItemData(["compte_email", "compte_email_utilisateur", "utilisateur"], container, function (action, itemData) {
        window.setTimeout(function () {
            if (option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().length == 0) {
                mConstruit()
            }
        }, 100)
    })

    var ctrlResize = null;
    function mConstruit() {
        container.empty()

        if (option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().length == 0) {
            var $DivFlex = $("<div style='display:flex;align-items:center;justify-content:center;width:100%;height:100%;'/>").appendTo(container)
            var $DivCenter = $("<div style='text-align:center;'/>").appendTo($DivFlex)
            $("<i class='fas fa-envelope-open' style='font-size:500%;opacity:0.5;'/>").appendTo($DivCenter)
            $("<br/>").appendTo($DivCenter)
            $("<br/>").appendTo($DivCenter)
            $("<div style='font-size:140%;opacity:0.5;'>Boite d'envoi et réception d'email<br/><br/></div>").appendTo($DivCenter)
            $("<div style=''>Pour pouvoir utliser les emails,<br/></div>").appendTo($DivCenter)
            var $Div = $("<div style=''>vous devez créer au moins une adresse email</div>").appendTo($DivCenter)

            $("<div/>").appendTo($DivCenter).dxCtrlButton({
                text: "Configurer une nouvelle adresse email",
                onClick: function (e) {
                    option.bddCtrl.getObjet("compte_email").objetMetier.mShowPopupNew()
                }
            })
            function mVerif() {
                if (option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().length == 0) {
                    window.setTimeout(function () { mVerif() }, 1500)
                } else {
                    mConstruit()
                }
            }
            mVerif()
        } else {
            ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
                bddCtrl: option.bddCtrl,
                context_grid: option.context_grid,
                withMarge: true,
                widthLeftInitial: 300
            }).dxCtrlSplitterResize2("instance")
            ctrlResize.mConstruitRight(function (contentElement) {
            })
            ctrlResize.mConstruitLeft(function (contentElement) {
                mConstruitMenu(contentElement)
            })
        }
    }

    var dxCtrlGridEmail = null;
    function mConstruitMenu(contentElement) {
        contentElement.css("position", "relative")

        var $DivEntete = $('<div></div>').appendTo(contentElement)
        var lstButtons = []
        lstButtons.push({
            icon: "fas fa-envelope",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            hint: "Nouvel email",
            height: 28,
            width: 28,
            onClick: function (e) {
                e.event.stopPropagation()
                option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
            }
        })
        $("<div/>").appendTo($DivEntete).dxCtrlEnteteMenuPage({
            bddCtrl: option.bddCtrl,
            icone: "fas fa-envelope-open-text",
            title: "Emails",
            buttons: lstButtons
        })


        var $DivDetail = $("<div/>").appendTo(contentElement)
        mConstruitMenuEmailQuotidien($DivDetail)

        resizeObserver.mAdd($DivEntete, function () { $DivDetail.css("height", "calc(100% - " + $DivEntete.innerHeight() + "px)") })()

        //var dsAccord = [{ id: 1, text: "Email", icon: "fas fa-envelope-open-text" }]
        ////dsAccord.push({ id: 2, text: "Emailing", icon: "fas fa-square-envelope" })
        //var inItemClosed = false
        //$("<div style='height:calc(100% - 5px)' class='dx-accordion-hide-chevron'/>").appendTo(contentElement).dxCtrlAccordion({
        //    dataSource: dsAccord,
        //    multiple: false,
        //    autoHeight: true,
        //    selectedIds: [1],
        //    disableCloseOnClick: true,
        //    itemTitleTemplate: function (itemData, itemIndex, itemElement) {
        //        itemData.titleElement = itemElement
        //        itemElement.css("position", "relative")
        //        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(itemElement)
        //        var $Tr = $("<tr/>").appendTo($Table)
        //        var $Td = $("<td style='width:28px;font-size:160%;'><i class='" + itemData.icon + "'></i></td>").appendTo($Tr)
        //        var $Td = $("<td style='width:100%;color:" + theme.backgroundcolorAccent + ";font-size:160%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'>" + itemData.text + "</td>").appendTo($Tr)
        //        if (itemData.id == "1") {
        //            //var $TdNew = $("<td style='width:35px;padding-right:5px;'></td>").appendTo($Tr)
        //            //$("<div style='display:inline-block;'/>").appendTo($TdNew).dxCtrlButton({
        //            //    icon: "fas fa-at",
        //            //    icon2: "fas fa-certificate",
        //            //    colorIcone2: theme.colorBtIcon2,
        //            //    opacityIcone2: "0.9",
        //            //    txtTooltip: "Ajouter une nouvelle adresse email",
        //            //    height: 28,
        //            //    width: 28,
        //            //    onClick: function (e) {
        //            //        e.event.stopPropagation()
        //            //        option.bddCtrl.getObjet("compte_email").objetMetier.mShowPopupNew()
        //            //    }
        //            //})
        //            var $TdNew = $("<td style='width:30px;'></td>").appendTo($Tr)
        //            $("<div/>").appendTo($TdNew).dxCtrlButton({
        //                icon: "fas fa-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                hint: "Nouvel email",
        //                height: 28,
        //                width: 28,
        //                onClick: function (e) {
        //                    e.event.stopPropagation()
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        } else if (itemData.id == "2") {
        //            var $TdNew = $("<td style='width:35px;padding-right:5px;'/>").appendTo($Tr)
        //            $("<div style='display:inline-block;'/>").appendTo($TdNew).dxCtrlButton({
        //                icon: "fas fa-envelope-open-text",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                icon3: "fas fa-boxes",
        //                opacityIcone3: "0.7",
        //                colorIcone3: theme.colorBtIcon3,
        //                leftIcone3: true,
        //                txtTooltip: "Nouveau document email dans la box",
        //                height: 28,
        //                width: 28,
        //                onClick: function (e) {
        //                    e.event.stopPropagation();
        //                    (new cObjetFichierEmlzMetier(null, option.bddCtrl)).mShowNewDocumentEmail()
        //                }
        //            })
        //            var $TdNew = $("<td style='width:30px;'></td>").appendTo($Tr)
        //            $("<div style='display:inline-block;'/>").appendTo($TdNew).dxCtrlButton({
        //                icon: "fas fa-square-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouveau emailing",
        //                height: 28,
        //                width: 28,
        //                onClick: function (e) {
        //                    e.event.stopPropagation()
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail(true)
        //                }
        //            })
        //        }
        //    },
        //    itemTemplate: function (itemData, itemIndex, itemElement) {
        //        itemElement.empty()
        //        switch (itemData.id) {
        //            case 1:
        //                mConstruitMenuEmailQuotidien(itemElement)
        //                break;
        //            case 2:
        //                mConstruitMenuEmailing(itemElement)
        //                break;
        //        }
        //    }
        //})
    }

    function mConstruitMenuEmailQuotidien(itemElement) {
        itemElement.empty()
        var $DivMenu = $("<div style='height:calc(100% - 46px);width:100%;'/>").appendTo(itemElement).dxCtrlMenuEmail({
            bddCtrl: option.bddCtrl,
            collapsible: true,
            context_grid: "page_email_quotidien",
            onSelectionChanged: function (itemDataCompteEmail, itemDataMenu, idTypeCom, lstIdTypeClassement) {
                //dxListMenu.unselectAll()
                if (itemDataCompteEmail == null) {
                    //on a tout fermé
                    ctrlResize.mConstruitRight(function (contentElement) {
                        contentElement.empty()
                    })
                } else {
                    ctrlResize.mConstruitRight(function (contentElement) {
                        contentElement.css("position", "relative")
                        contentElement.empty()
                        //liste noire ou liste bounce
                        if (typeof itemDataMenu.id_classeur != 'undefined') {
                            //on est sur un classeur
                            $("<div/>").appendTo(contentElement).dxCtrlGridClasseurElement({
                                bddCtrl: option.bddCtrl,
                                context_grid: "grid_activite_classeur",
                                idClasseur: itemDataMenu.id_classeur
                            }).dxCtrlGridClasseurElement("instance")
                        } else if (typeof itemDataMenu.id_dates != 'undefined') {
                            //on est sur une dates
                            $("<div/>").appendTo(contentElement).dxCtrlGridDatesElement({
                                bddCtrl: option.bddCtrl,
                                context_grid: "grid_activite_dates",
                                idDates: itemDataMenu.id_dates
                            }).dxCtrlGridClasseurElement("instance")
                        } else if (typeof itemDataMenu.id_tournee != 'undefined') {
                            //on est sur une tournee
                            option.bddCtrl.mAjaxCall({
                                command: "getlstdatefromtournee",
                                id_tournee: itemDataMenu.id_tournee
                            }, function (data) {
                                if (typeof data.lst_dates == 'undefined') data.lst_dates = []
                                var lstIdDates = []
                                data.lst_dates.forEach(function (dataDates) { lstIdDates.push(dataDates.id_dates) })
                                if (lstIdDates.length == 0) lstIdDates.push(0)
                                $("<div/>").appendTo(contentElement).dxCtrlGridDatesElement({
                                    bddCtrl: option.bddCtrl,
                                    context_grid: "grid_activite_dates",
                                    idDates: lstIdDates
                                }).dxCtrlGridClasseurElement("instance")
                            })
                        } else {
                            switch (parseInt(itemDataMenu.id)) {
                                case 0:
                                    $("<div/>").appendTo(contentElement).dxCtrlDashBoard({
                                        bddCtrl: option.bddCtrl,
                                        context_grid: "dashboardemail",
                                        selectedkey: "email",
                                        data: JSON.parse('[{"x":0,"y":0,"w":5,"h":6,"key":"email_vue"},{"x":5,"y":0,"w":5,"h":6,"key":"email_click"},{"x":10,"y":0,"w":5,"h":6,"key":"email_reactivite"},{"x":15,"y":0,"w":5,"h":21,"key":"email_repartclick"},{"x":0,"y":6,"w":15,"h":6,"key":"email_resumeenvoi"},{"x":0,"y":12,"w":15,"h":9,"key":"email_histoenvoivueclick"},{"x":0,"y":21,"w":20,"h":10,"key":"email_toplstclick"}]')
                                    }) 
                                case 7:
                                    $("<div/>").appendTo(contentElement).dxCtrlGridAdresseEmailListeNoire({
                                        bddCtrl: option.bddCtrl,
                                    })
                                    break;
                                case 8:
                                    $("<div/>").appendTo(contentElement).dxCtrlGridAdresseEmailBounce({
                                        bddCtrl: option.bddCtrl
                                    })
                                    break;
                                case 9: //tracking vue
                                    $("<div/>").appendTo(contentElement).dxCtrlGridComDestinataireTrackingVueEmail({
                                        bddCtrl: option.bddCtrl,
                                        showVoirDoc: true
                                    })
                                    break;
                                case 10://tracking click
                                    $("<div/>").appendTo(contentElement).dxCtrlGridComDestinataireTrackingClickEmail({
                                        bddCtrl: option.bddCtrl,
                                        showVoirDoc: true
                                    })
                                    break;
                                default:
                                    var $Icone = $("<i class='" + itemDataMenu.icon + "' style='position:relative;'></i>")
                                    if (typeof itemDataMenu.icon2 != 'undefined') {
                                        var $Icone2 = $("<i class='" + itemDataMenu.icon2 + "' style='position:absolute;bottom:-1px;right:-1px;color:" + theme.backgroundcolorAccent + ";font-size:70%;'></i>").appendTo($Icone);
                                        if (typeof itemDataMenu.color2 != 'undefined') $Icone2.css("color", itemDataMenu.color2)
                                    }
                                    switch (parseInt(idTypeCom)) {
                                        case 1: //Recu
                                            $("<div/>").appendTo(contentElement).dxCtrlGridEmailRecu({
                                                bddCtrl: option.bddCtrl,
                                                adresse_email: itemDataCompteEmail.adresse_email, //Favori ou adresse_email
                                                lstIdTypeClassement: lstIdTypeClassement
                                            })
                                            break;
                                        case 2: //envoi
                                            var opt = {
                                                bddCtrl: option.bddCtrl,
                                                context_grid: "email_envoi_" + lstIdTypeClassement[0],
                                                adresse_email: itemDataCompteEmail.adresse_email, //Favori ou adresse_email
                                                lstIdTypeClassement: lstIdTypeClassement
                                            }
                                            if (itemDataMenu.id == 99 || itemDataMenu.id.startsWith("99_")) {
                                                //mailing email
                                                opt.lstLstConditionBase = [[{ nom_champ: "presentation_mailing", ope: "ismailing" }]]
                                                switch (itemDataMenu.id) {
                                                    case "99": opt.noDataText = "Aucun mailing email"; break;
                                                    case "99_5": opt.noDataText = "Aucun mailing email envoyé"; break;
                                                    case "99_3": opt.noDataText = "Aucun mailing email en cours"; break;
                                                    case "99_7": opt.noDataText = "Aucun mailing email brouillon"; break;
                                                }
                                            } else {
                                                opt.lstLstConditionBase = [[{ nom_champ: "presentation_mailing", ope: "notismailing" }]]
                                            }
                                            $("<div/>").appendTo(contentElement).dxCtrlGridEmailEnvoi(opt)
                                            break;
                                    }
                                    break;
                            }
                        }
                    })
                }
            }
        })
        if (Math.ceil(Math.abs(option.bddCtrl.utiCourantParaJson.date_premier_demarrage - (new Date())) / (1000 * 60 * 60 * 24)) <= 3) {
            $("<div style='margin:5px'/>").appendTo(itemElement).dxCtrlButton({
                text: "Nouvelle adresse email",
                width: "100%",
                onClick: function (e) {
                    option.bddCtrl.getObjet("compte_email").objetMetier.mShowPopupNew()
                }
            })
        } else {
            $DivMenu.css("height", "100%")
        }
    }

    function mConstruitMenuEmailing(itemElement) {
        itemElement.empty()
        var $DivMenu = $("<div style='height:100%;width:100%;'/>").appendTo(itemElement).dxCtrlMenuEmail({
            bddCtrl: option.bddCtrl,
            forEmailing: true,
            collapsible: false,
            context_grid: "page_email_mailing",
            onSelectionChanged: function (itemDataCompteEmail, itemDataMenu, idTypeCom, lstIdTypeClassement) {
                //dxListMenu.unselectAll()
                ctrlResize.mConstruitRight(function (contentElement) {
                    contentElement.css("position", "relative")
                    contentElement.empty()
                    //liste noire ou liste bounce
                    switch (String(itemDataMenu.id)) {
                        case "c0":
                            $("<div/>").appendTo(contentElement).dxCtrlDashBoard({
                                bddCtrl: option.bddCtrl,
                                context_grid: "dashboardemail",
                                selectedkey: "email",
                                data: JSON.parse('[{"x":0,"y":0,"w":5,"h":4,"key":"email_vue"},{"x":5,"y":0,"w":5,"h":4,"key":"email_click"},{"x":10,"y":0,"w":5,"h":4,"key":"email_reactivite"},{"x":15,"y":0,"w":5,"h":21,"key":"email_repartclick"},{"x":0,"y":4,"w":15,"h":6,"key":"email_resumeenvoi"},{"x":0,"y":10,"w":15,"h":11,"key":"email_histoenvoivueclick"},{"x":0,"y":21,"w":20,"h":10,"key":"email_toplstclick"}]')
                            })
                        case "c7":
                            $("<div/>").appendTo(contentElement).dxCtrlGridAdresseEmailListeNoire({
                                bddCtrl: option.bddCtrl,
                            })
                            break;
                        case "c8":
                            $("<div/>").appendTo(contentElement).dxCtrlGridAdresseEmailBounce({
                                bddCtrl: option.bddCtrl
                            })
                            break;
                        case "c9": //tracking vue
                            $("<div/>").appendTo(contentElement).dxCtrlGridComDestinataireTrackingVueEmail({
                                bddCtrl: option.bddCtrl,
                                showVoirDoc: true
                            })
                            break;
                        case "c10"://tracking click
                            $("<div/>").appendTo(contentElement).dxCtrlGridComDestinataireTrackingClickEmail({
                                bddCtrl: option.bddCtrl,
                                showVoirDoc: true
                            })
                            break;
                        default:
                            var $Icone = $("<i class='" + itemDataMenu.icon + "' style='position:relative;'></i>")
                            if (typeof itemDataMenu.icon2 != 'undefined') {
                                var $Icone2 = $("<i class='" + itemDataMenu.icon2 + "' style='position:absolute;bottom:-1px;right:-1px;color:" + theme.backgroundcolorAccent + ";font-size:70%;'></i>").appendTo($Icone);
                                if (typeof itemDataMenu.color2 != 'undefined') $Icone2.css("color", itemDataMenu.color2)
                            }
                            switch (parseInt(idTypeCom)) {
                                case 1:
                                    $("<div/>").appendTo(contentElement).dxCtrlGridEmailRecu({
                                        bddCtrl: option.bddCtrl,
                                        adresse_email: itemDataCompteEmail.adresse_email, //Favori ou adresse_email
                                        lstIdTypeClassement: lstIdTypeClassement
                                    })
                                    break;
                                case 2:
                                    var opt = {
                                        bddCtrl: option.bddCtrl,
                                        context_grid: "email_envoi_" + lstIdTypeClassement[0],
                                        adresse_email: itemDataCompteEmail.adresse_email, //Favori ou adresse_email
                                        lstIdTypeClassement: lstIdTypeClassement,
                                        isMailing: true
                                    }
                                    if (itemDataMenu.id == "c99" || itemDataMenu.id.startsWith("c99_")) {
                                        //mailing email
                                        opt.lstLstConditionBase = [[{ nom_champ: "presentation_mailing", ope: "ismailing" }]]
                                        switch (itemDataMenu.id) {
                                            case "c99": opt.noDataText = "Aucun mailing email"; break;
                                            case "c99_c5": opt.noDataText = "Aucun mailing email envoyé"; break;
                                            case "c99_c3": opt.noDataText = "Aucun mailing email en cours"; break;
                                            case "c99_c7": opt.noDataText = "Aucun mailing email brouillon"; break;
                                        }
                                    } else {
                                        opt.lstLstConditionBase = [[{ nom_champ: "presentation_mailing", ope: "notismailing" }]]
                                    }
                                    $("<div/>").appendTo(contentElement).dxCtrlGridEmailEnvoi(opt)
                                    break;
                                default:
                                    if (typeof itemDataMenu.id_classeur != 'undefined') {
                                        //on est sur un classeur
                                        $("<div/>").appendTo(contentElement).dxCtrlGridClasseurElement({
                                            bddCtrl: option.bddCtrl,
                                            context_grid: "grid_activite_classeur",
                                            idClasseur: itemDataMenu.id_classeur
                                        }).dxCtrlGridClasseurElement("instance")
                                    } else if (typeof itemDataMenu.id_dates != 'undefined') {
                                        //on est sur une dates
                                        $("<div/>").appendTo(contentElement).dxCtrlGridDatesElement({
                                            bddCtrl: option.bddCtrl,
                                            context_grid: "grid_activite_dates",
                                            idDates: itemDataMenu.id_dates
                                        }).dxCtrlGridClasseurElement("instance")
                                    } else if (typeof itemDataMenu.id_tournee != 'undefined') {
                                        //on est sur une tournee
                                        option.bddCtrl.mAjaxCall({
                                            command: "getlstdatefromtournee",
                                            id_tournee: itemDataMenu.id_tournee
                                        }, function (data) {
                                            if (typeof data.lst_dates == 'undefined') data.lst_dates = []
                                            var lstIdDates = []
                                            data.lst_dates.forEach(function (dataDates) { lstIdDates.push(dataDates.id_dates) })
                                            if (lstIdDates.length == 0) lstIdDates.push(0)
                                            $("<div/>").appendTo(contentElement).dxCtrlGridDatesElement({
                                                bddCtrl: option.bddCtrl,
                                                context_grid: "grid_activite_dates",
                                                idDates: lstIdDates
                                            }).dxCtrlGridClasseurElement("instance")
                                        })
                                    }
                                    break;
                            }
                            break;
                    }
                })
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}